export interface BillingRulesInterface {
  id: string;
  asOf: string;
  defaultRateInCents?: number;
  status?: string;
  serviceIds?: string[];
  locationIds?: string[];
  payerIds?: string[];
  billingSolutionId?: string;
  // Associations
  services?: Array<{id: string; name: string}>;
  locations?: Array<{id: string; name: string}>;
  payers?: Array<{id: string; name: string}>;
  billingSolution?: {id: string; name: string};
}

export class BillingRule implements BillingRulesInterface {
  id: string;
  asOf: string;
  defaultRateInCents?: number;
  status?: string;
  serviceIds?: string[];
  locationIds?: string[];
  payerIds?: string[];
  billingSolutionId?: string;
  services?: Array<{id: string; name: string}>;
  locations?: Array<{id: string; name: string}>;
  payers?: Array<{id: string; name: string}>;
  billingSolution?: {id: string; name: string};

  constructor(data: Partial<BillingRulesInterface>) {
    this.id = data.id || '';
    this.asOf = data.asOf || '';
    this.defaultRateInCents = data.defaultRateInCents;
    this.status = data.status || 'active';
    this.serviceIds = data.serviceIds || [];
    this.locationIds = data.locationIds || [];
    this.payerIds = data.payerIds || [];
    this.billingSolutionId = data.billingSolutionId || '';
    this.services = data.services || [];
    this.locations = data.locations || [];
    this.payers = data.payers || [];
    this.billingSolution = data.billingSolution;
  }

  toJson(): BillingRulesInterface {
    return {
      id: this.id,
      asOf: this.asOf,
      defaultRateInCents: this.defaultRateInCents,
      status: this.status,
      serviceIds: this.serviceIds,
      locationIds: this.locationIds,
      payerIds: this.payerIds,
      billingSolutionId: this.billingSolutionId,
    };
  }
}
